import React, { useState } from 'react';

const FleetSection = () => {
  const features = [{
    label: "Seating",
    value: "Up to 7 passengers"
  }, {
    label: "Interior",
    value: "Premium leather seating"
  }, {
    label: "Comfort",
    value: "Climate control, heated seats"
  }, {
    label: "Entertainment",
    value: "WiFi, premium sound system"
  }, {
    label: "Amenities",
    value: "Bottled water, charging ports"
  }, {
    label: "Privacy",
    value: "Tinted windows, partition"
  }];

  const sprinterFeatures = [{
    label: "Seating",
    value: "Up to 14 passengers"
  }, {
    label: "Interior",
    value: "Premium leather seating"
  }, {
    label: "Comfort",
    value: "Climate control, premium seating"
  }, {
    label: "Entertainment",
    value: "WiFi, premium sound system"
  }, {
    label: "Amenities",
    value: "Bottled water, charging ports"
  }, {
    label: "Space",
    value: "Ample luggage capacity"
  }];

  const [showModal, setShowModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState('');

  const handleBooking = () => {
    const subject = `TiLimousine Booking Request for ${selectedVehicle}`;
    const body = `Vehicle: ${selectedVehicle}\nName: \nPhone: \nPickup Location: \nDrop-off Location: \nDate & Time: \nAirport Name: \nFlight Number: \nSpecial Requests: `;
    window.location.href = `mailto:contact@tilimousine.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return <section id="fleet" className="py-20 bg-[#050505]">
      <div className="container mx-auto px-4">
        <h2 className="section-title text-center pb-3 mb-12">Our Fleet</h2>
        
        {/* Cadillac Escalade */}
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 mb-20">
          <div className="lg:w-1/2">
            <div className="relative">
              <img 
                alt="Cadillac Escalade" 
                className="w-full h-[400px] object-contain" 
                src="https://di-sitebuilder-assets.dealerinspire.com/GMimages/gmMLP/cadillac/Escalade/2024/Colors/Black+Raven.png" 
              />
              <div className="absolute -bottom-12 -right-4 bg-black border border-gold/50 py-2 px-4 rounded">
                <p className="font-cinzel text-gold text-lg">Cadillac Escalade</p>
              </div>
            </div>
          </div>
          
          <div className="lg:w-1/2 mt-8 lg:mt-0">
            <h3 className="font-cinzel text-3xl text-gold mb-4">Luxury Executive SUV</h3>
            <p className="text-white/80 mb-6 leading-relaxed">
              Experience unparalleled luxury with our Cadillac Escalade. This premium SUV combines 
              sophisticated design with cutting-edge technology, offering a first-class experience 
              for discerning clients. Perfect for executive travel and special events.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {features.map((feature, index) => <div key={index} className="flex items-baseline">
                  <span className="text-gold mr-2">•</span>
                  <div>
                    <span className="font-cinzel text-gold">{feature.label}:</span>
                    <span className="text-white/70 ml-2">{feature.value}</span>
                  </div>
                </div>)}
            </div>
            
            <button className="gold-btn" onClick={() => {
              const subject = `TiLimousine Booking Request for Cadillac Escalade`;
              const body = `Vehicle: Cadillac Escalade\nName: \nPhone: \nPickup Location: \nDrop-off Location: \nDate & Time: \nAirport Name: \nFlight Number: \nSpecial Requests: `;
              window.location.href = `mailto:contact@tilimousine.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            }}>
              Book This Car
            </button>
          </div>
        </div>

        {/* Chevrolet Suburban */}
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 mb-20">
          <div className="lg:w-1/2">
            <div className="relative">
              <img 
                alt="Chevrolet Suburban" 
                className="w-full h-[400px] object-contain scale-75" 
                src="https://www.chevrolet.com/content/dam/chevrolet/na/us/english/vdc-collections/2025/suvs/suburban/trim-walk/v2/2025-suburban-ck10906-1lt-gba-trimselector.png?imwidth=1200" 
              />
              <div className="absolute -bottom-12 -right-4 bg-black border border-gold/50 py-2 px-4 rounded">
                <p className="font-cinzel text-gold text-lg">Chevrolet Suburban</p>
              </div>
            </div>
          </div>
          
          <div className="lg:w-1/2 mt-8 lg:mt-0">
            <h3 className="font-cinzel text-3xl text-gold mb-4">Premium Luxury SUV</h3>
            <p className="text-white/80 mb-6 leading-relaxed">
              The cornerstone of our fleet, the Chevrolet Suburban represents the perfect balance 
              of sophistication, comfort, and functionality. This spacious luxury SUV offers ample room 
              for both passengers and luggage while maintaining an elegant profile suitable for executive 
              travel and special occasions.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {features.map((feature, index) => <div key={index} className="flex items-baseline">
                  <span className="text-gold mr-2">•</span>
                  <div>
                    <span className="font-cinzel text-gold">{feature.label}:</span>
                    <span className="text-white/70 ml-2">{feature.value}</span>
                  </div>
                </div>)}
            </div>
            
            <button className="gold-btn" onClick={() => {
              const subject = `TiLimousine Booking Request for Chevrolet Suburban`;
              const body = `Vehicle: Chevrolet Suburban\nName: \nPhone: \nPickup Location: \nDrop-off Location: \nDate & Time: \nAirport Name: \nFlight Number: \nSpecial Requests: `;
              window.location.href = `mailto:contact@tilimousine.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            }}>
              Book This Car
            </button>
          </div>
        </div>

        {/* Mercedes-Benz Sprinter */}
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="relative">
              <img 
                alt="Mercedes-Benz Sprinter" 
                className="w-full h-[400px] object-contain" 
                src="https://di-shared-assets.dealerinspire.com/legacy/rackspace/ldm-images/2018-Mercedes_Benz-Sprinter-COLORS-Obsidian-Black-Metallic.png" 
              />
              <div className="absolute -bottom-12 -right-4 bg-black border border-gold/50 py-2 px-4 rounded">
                <p className="font-cinzel text-gold text-lg">Mercedes-Benz Sprinter</p>
              </div>
            </div>
          </div>
          
          <div className="lg:w-1/2 mt-8 lg:mt-0">
            <h3 className="font-cinzel text-3xl text-gold mb-4">Premium Group Transportation</h3>
            <p className="text-white/80 mb-6 leading-relaxed">
              Our Mercedes-Benz Sprinter is the perfect solution for group transportation needs. 
              With spacious seating for up to 14 passengers and ample luggage space, it's ideal 
              for corporate events, airport transfers, and group outings.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {sprinterFeatures.map((feature, index) => <div key={index} className="flex items-baseline">
                  <span className="text-gold mr-2">•</span>
                  <div>
                    <span className="font-cinzel text-gold">{feature.label}:</span>
                    <span className="text-white/70 ml-2">{feature.value}</span>
                  </div>
                </div>)}
            </div>
            
            <button className="gold-btn" onClick={() => {
              const subject = `TiLimousine Booking Request for Mercedes-Benz Sprinter`;
              const body = `Vehicle: Mercedes-Benz Sprinter\nName: \nPhone: \nPickup Location: \nDrop-off Location: \nDate & Time: \nAirport Name: \nFlight Number: \nSpecial Requests: `;
              window.location.href = `mailto:contact@tilimousine.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            }}>
              Book This Car
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="booking-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="booking-modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">Book {selectedVehicle}</h3>
            <p className="modal-desc">How would you like to book?</p>
            <div className="modal-actions">
              <a 
                href={`mailto:contact@tilimousine.com?subject=TiLimousine%20Booking%20Request%20for%20${encodeURIComponent(selectedVehicle)}&body=Vehicle%3A%20${encodeURIComponent(selectedVehicle)}%0AName%3A%20%0APhone%3A%20%0APickup%20Location%3A%20%0ADrop-off%20Location%3A%20%0ADate%20%26%20Time%3A%20%0AAirport%20Name%3A%20%0AFlight%20Number%3A%20%0ASpecial%20Requests%3A%20`} 
                className="gold-btn modal-btn"
              >
                Book by Email
              </a>
              <a href="tel:+18573123332" className="gold-btn modal-btn">Book by Phone</a>
            </div>
            <button className="modal-close" onClick={() => setShowModal(false)}>&times;</button>
          </div>
        </div>
      )}
    </section>;
};

export default FleetSection;
